import { Box, styled } from "@mui/material";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import ErrorBoundary from "../../Common/_components/ErrorBoundary";
import { useAppSelector } from "../../Common/_hooks/useAppSelector";
import type ViewProductStore from "../../AppData/_stores/ViewProductStore";
import ProductCatalogCardImage from "../../ProductCatalog/Card/ProductCatalogCardImage";
import ProductImage from "./ProductImage";

const StyledButton = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  height: '64px',
  lineHeight: '18px',
  minWidth: 0,
  //padding: '0px 10px 0px 15px',
  padding: theme.spacing(0, 1, 0, 2),
  transition: 'background-color 150ms',
  width: '100%',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },

  '&.active': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
  [theme.breakpoints.down('md')]: {
    flex: '1 1 auto',
    height: '100%',
    padding: theme.spacing(0, 1, 0, 2),
  },
}))

const StyledButtonText = styled('div')(({ theme }) => ({
  flex: '1 1 auto',
  marginRight: '10px',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',

  [theme.breakpoints.down('md')]: {
    marginRight: theme.spacing(0.5),
  },
}))

const ProductSelectorButtonRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  minWidth: 0,

  [theme.breakpoints.down('md')]: {
    flex: '1 1 0',
  },
}))

interface Props {
  opened: boolean
  selectedViewProduct?: ViewProductStore
  onClick: () => void
}

export default function ProductSelectorButton(props:Props) {
  const activeProductId = useAppSelector(state => state.get('UIData').get('designLab').get('activeProductId'));
  const selectedProductId = props.selectedViewProduct?.get('id_product') ?? activeProductId;
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(selectedProductId)));
  const productName = props.selectedViewProduct?.get('name') ?? productData?.get('name');

  return productData ? <ProductSelectorButtonRoot>
    <StyledButton
      className={props.opened ? 'active' : ''}
      onClick={props.onClick}
    >
      <Box
        component="div"
        sx={{
          width: {
            xs: '25px',
            md: '36px',
          },
          height: {
            xs: '25px',
            md: '36px',
          },
          borderRadius: '24px',
          overflow: 'hidden',
          marginRight: {
            xs: '8px',
            md: '15px',
          },
          flexShrink: 0,
          position: 'relative',

          '& .product-catalog-card-hover-image': {
            display: 'none',
          },
        }}
      >
        <ErrorBoundary fallback={<></>}>
          {props.selectedViewProduct !== undefined
            ? <ProductCatalogCardImage
                slug={props.selectedViewProduct.get('slug')}
                name={props.selectedViewProduct.get('name')}
                sizes="36px"
                loading="eager"
              />
            : <ProductImage
              slug={productData.get('slug')}
              width={48}
              height={48}
            />}
        </ErrorBoundary>
      </Box>
      <StyledButtonText>{productName}</StyledButtonText>
      <ArrowDropDownRoundedIcon
        style={{
          flexShrink: 0,
          marginLeft: 'auto',
          transform: props.opened ? 'rotate(180deg)' : '',
          transition: 'transform 250ms',
        }}
      />
    </StyledButton>
  </ProductSelectorButtonRoot> : null
}
